module.exports = __webpack_public_path__ + "static/leda-homecare-respite-care-0976f3ebe72162f65921c8e6de2f5612.png";